import React, { useEffect, useState } from 'react'
import { useListVals } from 'react-firebase-hooks/database'
import { useHistory } from 'react-router-dom'
import ReactTimeAgo from 'react-time-ago'
import styled from 'styled-components'
import { NotificationDb } from '../../firebaseConfig'
import { fixedAssets } from 'src/containers/PreCache'
import { Loader } from 'src/components/shared/Loader'
import MobileHeader from 'src/components/MobileHeader'
import { IoClose } from 'react-icons/io5'
import MobileLayout from '../MobileLayout'
import routes from 'src/routes'
import { Button } from 'react-bootstrap'

const MobileNotifications = () => {
  const [values, loading, error] = useListVals(NotificationDb)
  const history = useHistory()
  const [notification, setNotification] = useState(null)

  const goBack = () => {
    history.goBack()
  }

  const refreshPage = () => {
    window.location.reload()
  }

  const handleRedirect = (url) => {
    history.push(url)
  }

  useEffect(() => {
    const newItems = values.length - localStorage.getItem('IA_notifications')
    let updated = values
      .sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
      .map((item, index) => {
        return {
          ...item,
          read: index < newItems ? false : true,
        }
      })
    setNotification(updated)
    if (values.length > localStorage.getItem('IA_notifications')) {
      localStorage.setItem('IA_notifications', values.length)
    }
  }, [loading, values])

  return (
    <MobileLayout title="Notifications" route={routes.lobby}>
      <Page>
        <main className="">
          {loading ? (
            <Loader />
          ) : error ? (
            <button onClick={refreshPage}>Connection failed. Click here to refresh.</button>
          ) : (
            notification.map((item, index) => {
              return (
                <div className={`item-wrapper ${!item.read && 'unread'}`} key={index}>
                  <div className="item-content">
                    <p className="item-content-label">{item.message}</p>
                    <p className="item-content-time">{item.datetime && <ReactTimeAgo date={item.datetime} />}</p>
                  </div>
                  {item.url && (
                    <Button type="button" onClick={() => handleRedirect(item.url)} className="theme-btn">
                      Enter
                    </Button>
                  )}
                </div>
              )
            })
          )}
        </main>
      </Page>
    </MobileLayout>
  )
}

const Page = styled.div`
  overflow-y: scroll;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(17.25px);
  -webkit-backdrop-filter: blur(17.25px);

  main {
    width: 98%;
    margin: auto;
    background: #fff;
    height: calc(100% - 60px);
    border-radius: 10px;
  }
  .time-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 5px;

    p {
      margin-bottom: 0px;
    }
  }
  .unread {
    background-color: rgba(209, 219, 226, 0.95);
  }

  .item-wrapper {
    width: 100%;
    padding: 15px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--blue-01);
    border-bottom: solid 1px #ccc;
  }

  .item-content {
    width: 100%;
    margin-left: 5px;
    margin-bottom: 0;
  }

  .item-content-label {
    font-size: 1.25rem;
    margin-bottom: 5px;
  }

  .item-content-time {
    font-size: 0.875rem;
    margin-bottom: 0;
  }

  .theme-btn {
    padding: 12px 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

`

export default MobileNotifications
